import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class WorkerRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    workerId: number;

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    workerCode: number;

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    workerName: string;

    @ApiProperty()
    @IsOptional()
    updatedUser?: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag?: number;

    @ApiProperty()
    isActive?: boolean;
    constructor(workerId: number,workerCode:number,workerName: string){
        this.workerId = workerId;
        this.workerCode = workerCode;
        this.workerName = workerName
        
    }
}